<template>
  <ion-app>
    <ion-menu side="end" menu-id="right-menu" content-id="main-container">
      <ion-header>
        <ion-toolbar translucent>
          <ion-title>منو</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list>
          <router-link to="/">
            <ion-item>
              <i class="far fa-home icon"></i>
              <ion-label>صفحه اصلی</ion-label>
            </ion-item>
          </router-link>
          <router-link v-if="false" to="/profile">

            <ion-item>
              <i class="far fa-user-circle icon"></i>
              <ion-label>پروفایل</ion-label>
            </ion-item>
          </router-link>
          <router-link to="/User/Info">
            <ion-item>
              <i class="far fa-id-badge icon"></i>
              <ion-label>اطلاعات شخصی</ion-label>
            </ion-item>
          </router-link>
          <router-link to="/ChangePassword">
            <ion-item>
              <i class="far fa-key icon"></i>
              <ion-label>تغییر گذرواژه</ion-label>
            </ion-item>
          </router-link>
          <router-link to="/Logout">
            <ion-item>
              <i class="far fa-sign-out-alt icon"></i>
              <ion-label>خروج از حساب کاربری</ion-label>
            </ion-item>
          </router-link>
          <ion-item @click="exitApp()">
            <i class="far fa-power-off icon"></i>
            <ion-label>خروج از برنامه</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet/>
  </ion-app>
</template>

<script>
import {IonApp, IonRouterOutlet,menuController} from '@ionic/vue';
import {defineComponent} from 'vue';
import {mapActions, mapGetters} from "vuex";
window.menuController = menuController;
import { Geolocation} from '@capacitor/core';
import { Plugins } from '@capacitor/core';

const { App, BackgroundTask } = Plugins;

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  },
  data(){
    return{
      location : null,
      position : null,
      taskId:null,
      locationInterval:null
    }
  },
  async mounted()
  {
    const self = this;
    this.getAndSaveMessageCount();
    this.getAndSaveActiveOrderCount();
    setInterval(function (){
      self.getAndSaveMessageCount();
      self.getAndSaveActiveOrderCount();
    },3*60*1000);
    // const options = {
    //   enableHighAccuracy: true,
    //   // timeout: 3000,
    //   maximumAge: 0
    // };
    // let last_request = 0;
    // Geolocation.watchPosition(options,function (data){
    //   if (data)
    //   {
    //     const now = new Date().getTime();
    //     if (last_request < (now - 300000))
    //     {
    //       last_request = new Date().getTime();
    //       const location = {lat: data.coords.latitude, lng: data.coords.longitude};
    //       self.sendVisitorLocation(location);
    //     }
    //   }
    // });
    self.getLocation();
    setInterval(function (){
      self.getLocation();
    },300000);



    App.addListener('appStateChange', state => {
      if (!state.isActive) {
        this.taskId = BackgroundTask.beforeExit(async () => {
          this.locationInterval = setInterval(()=>{
            try
            {
              this.getLocation();
            }
            catch (e)
            {
              console.log(e)
            }
            console.log('background is alive')
          },300000)
        });
      }
      else
      {
        try
        {
          console.log('TASK ID:',this.taskId)
          if (this.taskId)
          {
            const taskId = this.taskId;
            BackgroundTask.finish({taskId});
          }
          if (this.locationInterval)
          {
            try
            {
              clearInterval(this.locationInterval)
            }
            catch (e)
            {
              console.log(e)
            }
          }
        }
        catch (e)
        {
          console.log(e)
        }
      }
    });
  },
  methods:{
    ...mapActions('app',{
      getAndSaveMessageCount:"getMessageCount",
      getAndSaveActiveOrderCount:"getActiveOrderCount",
      sendVisitorLocation : 'sendVisitorLocation',
    }),
    getLocation()
    {
      const self = this;
      const options = {
        enableHighAccuracy: true,
        // timeout: 3000,
        maximumAge: 0
      };
      try
      {
        Geolocation.getCurrentPosition(options).then(function (data){
          const location = {lat: data.coords.latitude, lng: data.coords.longitude};
          self.sendVisitorLocation(location);
        })
      }catch (e)
      {
        console.log('error location');
        //
      }
    },
    closeMenu()
    {
      menuController.close('right-menu');
    },
    exitApp()
    {
      try
      {
        navigator['app'].exitApp();
      }
      catch (e)
      {
        console.log(e)
      }
    },
  },
  computed:{
    ...mapGetters("auth", {
      currentUser: "getUserInfo",
    }),
  },
  watch:{
    "$route.path"()
    {
      this.closeMenu();
    }
  }
});
</script>

<style scoped="scoped">
ion-toolbar,ion-header{
  background: #172e79;
  --background: #172e79;
}
</style>
